import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IconRegistryService } from './services/icon-registry.service';
import {LoadingBarComponent} from './components/loading-bar/loading-bar.component';
import {RouterModule} from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'app-root',
    imports: [RouterOutlet,LoadingBarComponent,RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'eru-ui';

  constructor(private iconRegistry: IconRegistryService) {
    // Register icons immediately and synchronously
    //this.iconRegistry.registerIcons();
  }

  ngOnInit() {
    // Also ensure registration on init
    this.iconRegistry.registerIcons();
  }
}
